import type { ReactNode } from 'react';

/** Converts `#[] into an anchor tag */
export function Linkify({ children }: { children?: string }): ReactNode {
  if (!children) return null;
  const parts: ReactNode[] = [];
  let cursor = 0;
  let key = 0;
  for (let idx = children.indexOf('#['); idx !== -1; idx = children.indexOf('#[', cursor)) {
    const end = children.indexOf(']', idx);
    if (end === -1) break;
    parts.push(children.substring(cursor, idx));
    const [url, label] = children.substring(idx + 2, end).split('|');
    parts.push(
      <a key={key++} href={url} target="_blank" rel="noopener noreferrer">
        {label ?? url}
      </a>
    );
    cursor = end + 1;
  }
  parts.push(children.substring(cursor));
  return <>{parts}</>;
}
